import React from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";

export const LISTITEM_ICON_WIDTH = 30;

export const StyledListItemText = styled(ListItemText)({
  "& .MuiListItemText-primary": {
    //color: "red !important",
    fontSize: "12px",
  },
});

type MainMenuWithoutLinkProps = {
  handleMainMenuWithoutLinkOnClick: () => void;
  isMainMenuWithoutLinkOpen: boolean;
  children: JSX.Element;
  menuName: string;
};

const MainMenuWithoutLink = ({
  handleMainMenuWithoutLinkOnClick,
  isMainMenuWithoutLinkOpen,
  children,
  menuName,
}: MainMenuWithoutLinkProps) => {
  return (
    <ListItem
      disablePadding
      onClick={handleMainMenuWithoutLinkOnClick}
      key={menuName}
      sx={{ color: "white" }}
    >
      <ListItemButton sx={{ pt: "4px", pb: "4px" }}>
        <ListItemIcon sx={{ color: "inherit", minWidth: LISTITEM_ICON_WIDTH }}>
          {children}
        </ListItemIcon>
        <StyledListItemText primary={menuName} />
        {isMainMenuWithoutLinkOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    </ListItem>
  );
};

export default MainMenuWithoutLink;
